import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { cn } from "@/lib/utils";
import {
  formatCurrency,
  formatPts,
  type MemberTransaction,
} from "../data/mock-member-data";
import { EmptyState } from "./EmptyState";

const typeStyles = {
  Earned: "bg-emerald-50 text-emerald-800",
  Redeemed: "bg-violet-50 text-violet-800",
  Bonus: "bg-amber-50 text-amber-900",
  Adjustment: "bg-slate-100 text-slate-700",
};

const statusStyles = {
  Completed: "bg-emerald-50 text-emerald-700",
  Pending: "bg-amber-50 text-amber-700",
  Failed: "bg-rose-50 text-rose-700",
};

export function TransactionTable({
  rows,
}: {
  rows: MemberTransaction[];
}) {
  if (rows.length === 0) {
    return (
      <EmptyState
        title="No transactions found"
        description="Try adjusting your filters or check back after your next purchase."
      />
    );
  }

  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200">
      <Table>
        <TableHeader>
          <TableRow className="bg-slate-50/80 hover:bg-slate-50/80">
            <TableHead>Transaction ID</TableHead>
            <TableHead>Date & time</TableHead>
            <TableHead>Outlet</TableHead>
            <TableHead>Type</TableHead>
            <TableHead>Amount</TableHead>
            <TableHead>Points</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id} className="hover:bg-slate-50/70">
              <TableCell className="font-medium text-slate-900">
                {row.id}
              </TableCell>
              <TableCell>
                <div className="text-sm text-slate-800">{row.date}</div>
                <div className="text-xs text-slate-500">{row.time}</div>
              </TableCell>
              <TableCell className="text-slate-700">{row.outlet}</TableCell>
              <TableCell>
                <span
                  className={cn(
                    "inline-flex rounded-full px-2.5 py-1 text-xs font-medium",
                    typeStyles[row.type],
                  )}
                >
                  {row.type}
                </span>
              </TableCell>
              <TableCell className="text-slate-800">
                {row.amount > 0
                  ? formatCurrency(row.amount, row.currency)
                  : "—"}
              </TableCell>
              <TableCell>
                <span
                  className={cn(
                    "font-semibold",
                    row.points >= 0 ? "text-emerald-700" : "text-rose-600",
                  )}
                >
                  {formatPts(row.points)}
                </span>
              </TableCell>
              <TableCell>
                <span
                  className={cn(
                    "inline-flex rounded-full px-2.5 py-1 text-xs font-medium",
                    statusStyles[row.status],
                  )}
                >
                  {row.status}
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
